import { OidcUserExtendedInfo } from '../types/OidcUserExtendedInfo.tsx'
import { useOidcUser } from '@axa-fr/react-oidc'
import { appRoles } from '../global/config.tsx'
import { useAppSelector } from './reduxHooks.tsx'
import { useMemo } from 'react'
import { List } from 'immutable'

const useUserRoles = () => {
  const profile = useAppSelector((state) => state.register.selectedRegistration)
  const { oidcUser } = useOidcUser<OidcUserExtendedInfo>()
  const { role } = oidcUser || {}

  const rolesArray = useMemo(() => {
    return List(role ? (Array.isArray(role) ? role : [role]) : [])
  }, [role])

  const hasDocentIdOrInternal = useMemo(() => {
    return (profile && profile.adrId > 0) || (rolesArray.some((r) => appRoles.Intern.includes(r)) ?? false)
  }, [profile, rolesArray])

  const isInternal = useMemo(() => {
    return rolesArray.some((r) => appRoles.Intern.includes(r)) ?? false
  }, [rolesArray])

  const isDocentWithoutDocentId = useMemo(() => {
    return !(profile !== undefined && profile.adrId > 0 && rolesArray.some((r) => appRoles.Dozent.includes(r)))
  }, [profile, rolesArray])

  return { hasDocentIdOrInternal, isInternal, isDocentWithoutDocentId }
}

export default useUserRoles
